import React, {useEffect} from 'react';
import PageHeader from '../../../../common/components/ui/PageHeader';
import SectionPanel from '../../../../common/components/ui/SectionPanel';
import {OrderInvoiceFormContextProvider} from '../../contexts/OrderInvoiceFormContext';
import {useGlobalContext} from '../../../../common/components/core/GlobalContext';
import FieldCustomerName from '../../components/FieldCustomerName';
import FieldLinesArray from '../../components/FieldLinesArray';
import FieldIdNumber from '../../components/FieldIdNumber';
import FieldAddress from '../../components/FieldAddress';
import FieldPhoneFax from '../../components/FieldPhoneFax';
import FieldContact from '../../components/FieldContact';
import FieldEmailRecipients from '../../components/FieldEmailRecipients';
import LinesTotalWidget from '../../components/LinesTotalWidget';
import PopupSelectAction from '../../components/PopupSelectAction';
import FooterDivider from "../../../../common/components/ui/FooterDivider";
import FooterLogo from '../../../../common/components/ui/FooterLogo';
import styles from './OrderInvoice.module.scss';

const OrderInvoice = () => {
  const {setPageTitle} = useGlobalContext();
  useEffect(() => {
    setPageTitle((
      <PageHeader
        id={'orderInvoice-page-header'}
        defaultMessage={'Order Invoice'}
      />
    ));
  }, []);

  return (
    <OrderInvoiceFormContextProvider>
      <div className={styles.orderInvoiceContainer}>
        <SectionPanel>
          <div className={styles.upperFields}>
            <FieldCustomerName/>
            <FieldIdNumber/>
            <FieldPhoneFax/>
          </div>
          <div className={styles.bottomFields}>
            <FieldAddress/>
            <FieldContact/>
          </div>
          <FieldEmailRecipients/>
        </SectionPanel>
        <FieldLinesArray/>
        <LinesTotalWidget/>
        <SectionPanel>
          <PopupSelectAction/>
        </SectionPanel>
        <FooterDivider/>
        <FooterLogo/>
      </div>
    </OrderInvoiceFormContextProvider>
  );
};

export default OrderInvoice;
